import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { useConfirm } from "../ConfirmProvider";
import { fmtRoDate } from "../../lib/dateFmt";

export function Jurnal() {
  const { canDo } = useAuth();
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ title: "", category: "", content: "", date: new Date().toISOString().slice(0, 10) });

  const load = async () => { const { data } = await api.get("/management"); setRows(data); };
  useEffect(() => { load(); }, []);

  const submit = async () => {
    try {
      await api.post("/management", form);
      toast.success("Adăugat");
      setOpen(false);
      setForm({ title: "", category: "", content: "", date: new Date().toISOString().slice(0, 10) });
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Eroare"); }
  };
  const remove = async (id) => { if ((await confirm({ body: "Șterge?", danger: true }))) { await api.delete(`/management/${id}`); load(); } };

  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        {canDo("MANAGEMENT", "add") && (
          <Dialog open={open} onOpenChange={setOpen}>
            <Button onClick={() => setOpen(true)} className="bg-[var(--primary)]" data-testid="add-mgmt-btn"><Plus size={16}/> Intrare nouă</Button>
            <DialogContent>
              <DialogHeader><DialogTitle>Intrare jurnal</DialogTitle></DialogHeader>
              <div className="grid grid-cols-2 gap-3">
                <div><Label>Dată</Label><Input type="date" value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} /></div>
                <div><Label>Categorie</Label><Input value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} placeholder="Ședință, Decizie..." /></div>
                <div className="col-span-2"><Label>Titlu</Label><Input data-testid="mgmt-title" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} /></div>
                <div className="col-span-2"><Label>Conținut</Label><Textarea rows={5} value={form.content} onChange={(e) => setForm({ ...form, content: e.target.value })} /></div>
              </div>
              <DialogFooter>
                <Button variant="outline" onClick={() => setOpen(false)}>Anulează</Button>
                <Button onClick={submit} data-testid="submit-mgmt">Salvează</Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
        )}
      </div>
      <div className="space-y-3">
        {rows.map((r) => (
          <div key={r.id} className="card-flat p-5">
            <div className="flex items-center justify-between">
              <div>
                <div className="text-xs text-zinc-500">{fmtRoDate(r.date)} · {r.category || "General"}</div>
                <div className="font-display text-lg font-bold">{r.title}</div>
              </div>
              {canDo("MANAGEMENT", "delete") && <button onClick={() => remove(r.id)} className="text-red-600 p-1 hover:bg-red-50 rounded"><Trash2 size={14}/></button>}
            </div>
            {r.content && <div className="text-sm text-zinc-600 mt-3 whitespace-pre-wrap">{r.content}</div>}
          </div>
        ))}
        {rows.length === 0 && <div className="text-sm text-zinc-500">Nicio intrare în jurnal.</div>}
      </div>
    </div>
  );
}
